<template>

<app-section>

    <app-panel title="Organisations" :is-loading="is.loading" :is-empty="is.empty">

        <app-table>
            <thead>
                <tr>
                    <th>Name</th>
                    <th width="100" align="center">Users</th>
                    <th width="60"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in collection" :key="item.id">
                    <td>{{ item.name }}</td>
                    <td align="center">{{ item.users }}</td>
                    <td><app-button text="View" route="Organisation" :id="item.id" /></td>
                </tr>   
            </tbody>
        </app-table>

    </app-panel>

    <app-actions>

        <app-button text="Add Organisation" route="Organisation" id="create" />

    </app-actions>

</app-section>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

    mixins: [mixCollection],

    data: function() {
    
        return {
            api: 'organisations'
        }
    
    }

}

</script>

<style scoped>

</style>
